export const whyUsHero = {
  breadcrumb: "Why Us",
  eyebrow: "PERTH HOME AIR CONDITIONING",
  title: "The right Rinnai system starts",
  highlight: "with the right installer.",
  intro: "We are a Perth air conditioning business with more than 30 years of local experience, ARC Tick licensed installers and a dedicated focus on Rinnai. You deal with one local team from the first conversation to the finished installation.",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/b80105bc-e292-4256-9ccf-ad8e6bc6cfd6.jpg",
  imageAlt: "Installer fitting a linear ceiling air diffuser in a bright Perth home",
  facts: ["30+ years in Perth", "ARC Tick licensed", "Sister company of Langler Air"],
};

export const whyUsQuickAnswer = {
  question: "Why choose Perth Home Air Conditioning?",
  answer: "Because the installer decides how well any air conditioner performs. We size each system with a heat load assessment, design ducts and zones around how you live, and install with ARC Tick licensed technicians. We have served Perth homes for more than 30 years and specialise in Rinnai, so our advice is focused rather than generic.",
  points: [
    { label: "Local experience", value: "30+ years in Perth" },
    { label: "Licensing", value: "ARC Tick licensed installers" },
    { label: "Specialisation", value: "Rinnai residential systems" },
    { label: "Services", value: "Supply, installation and removal" },
    { label: "Quotes", value: "Free and no obligation" },
    { label: "Service area", value: "Perth metropolitan area" },
  ],
};

export const whyUsPromises = [
  {
    title: "Straight, specialist advice",
    text: "We specialise in Rinnai, so recommendations are focused, clear and free of brand-hopping.",
  },
  {
    title: "Sized for your home",
    text: "Every recommendation starts with your floor plan, orientation, glazing and how each room is used.",
  },
  {
    title: "ARC Tick licensed installers",
    text: "Refrigerant handling and installation by appropriately licensed air conditioning technicians.",
  },
  {
    title: "Supply, installation and removal",
    text: "One team supplies the system, installs it and removes the old unit where agreed in your quote.",
  },
  {
    title: "Clear written quotes",
    text: "You see the recommended system, zones and inclusions before you decide, with no obligation.",
  },
  {
    title: "A local point of contact",
    text: "Questions after installation come back to the same Perth team that designed your system.",
  },
];

export const whyUsComparison = {
  columns: ["", "Perth Home Air Conditioning", "Buying a unit online"],
  rows: [
    ["System sizing", "Heat load assessment for your home", "Often chosen by room size or price"],
    ["Ducts and zones", "Designed around how you live", "Not included"],
    ["Installation", "ARC Tick licensed technicians", "Arranged separately by you"],
    ["Old system removal", "Included where agreed in your quote", "Usually extra or not offered"],
    ["Accountability", "One local Perth team", "Retailer, installer and manufacturer"],
    ["Advice", "Rinnai specialists", "General retail guidance"],
  ],
};

export const whyUsSteps = [
  {
    title: "Enquire",
    text: "Send the quote form or call. Tell us what you are looking for, even if you are not sure yet.",
  },
  {
    title: "Talk it through",
    text: "A specialist calls to understand your home, rooms, current system and priorities.",
  },
  {
    title: "Assess and size",
    text: "Where needed we assess the property and calculate the heat load for each area.",
  },
  {
    title: "Clear written quote",
    text: "You receive the recommended Rinnai system, zones and inclusions in writing.",
  },
  {
    title: "Install and hand over",
    text: "We install, commission and show you how to get the most from your controls.",
  },
];

export const whyUsExperience = {
  eyebrow: "ESTABLISHED IN PERTH",
  title: "30+ years of Perth air conditioning experience.",
  text: "Perth Home Air Conditioning has served Perth homes for more than three decades. As the sister company of Langler Air, we draw on established local installation experience, now focused on a dedicated Rinnai residential offering.",
  points: [
    "30+ years serving Perth",
    "Sister company of Langler Air",
    "Residential specialists",
    "Perth metro coverage",
  ],
  image: "https://cdn.magicpatterns.com/patterns/generated-images/6d0072cf-1c17-4313-a0df-38bc8cdcd47e.jpg",
  imageAlt: "Contemporary single-storey Perth home in afternoon sun",
};

export const whyUsAreas = [
  {
    title: "Northern suburbs",
    text: "Including Joondalup, Wanneroo, Stirling and surrounding areas.",
  },
  {
    title: "Southern suburbs",
    text: "Including Fremantle, Cockburn, Melville and Rockingham.",
  },
  {
    title: "Eastern suburbs",
    text: "Including Swan, Bassendean, Bayswater and Belmont.",
  },
  {
    title: "Perth Hills",
    text: "Including Kalamunda, Mundaring and surrounding hills suburbs.",
  },
  {
    title: "Western and coastal suburbs",
    text: "Including Cottesloe, Nedlands, Subiaco and Cambridge.",
  },
  {
    title: "Central and south-east",
    text: "Including Victoria Park, Canning, Gosnells and Armadale.",
  },
];
